import { Images, RemoteImages } from "constants/images";
import { CardsContainer, HomePageContainer, MastheadImageContainer, MastheadImage } from "../../styles/home";
import FeatureCard from "./FeatureCard";
import ReferralView from "./referralView";
import Referrals from "./referrals";
import PromoWidget from "./promoWidget";
import ReferralEarnings from "./referralEarnings";
import { HomeDataProvider, useHomeData } from "../../contexts/HomeDataContext";
import FullPageShimmer from "./FullPageShimmer";
import Help from "../help";
import { useEffect, useRef } from "react";
import { logHomePageImpression } from "./analytics";
import { ProgressState } from "../../interfaces/home";
import { getImageKitUrl } from "utils/cdn";

const HomeContent = () => {
    const { isLoading, cities, referrals, banners, userData } = useHomeData();
    const hasTrackedImpression = useRef(false);

    useEffect(() => {
        if (isLoading || hasTrackedImpression.current) {
            return;
        }

        const widgetsDetails: Record<string, boolean> = {
            referralView: cities.state === ProgressState.COMPLETED && !!cities.data,
            referrals: referrals.state === ProgressState.COMPLETED && !!referrals.data?.length,
            promoWidget: banners.state === ProgressState.COMPLETED && !!banners.data?.length,
            referralEarnings: userData.state === ProgressState.COMPLETED && !!userData.data,
        };

        logHomePageImpression(widgetsDetails);
        hasTrackedImpression.current = true;
    }, [isLoading, cities, referrals, banners, userData]);

    if (isLoading) {
        return <FullPageShimmer />;
    }

    return (
        <>
            <MastheadImageContainer>
                <MastheadImage src={Images.homepageMastHead} />
                <Help />
            </MastheadImageContainer>
            <HomePageContainer>
                <CardsContainer>
                    <FeatureCard
                        text="Your Referrals"
                        iconSrc={getImageKitUrl(RemoteImages.referral, { width: 64, height: 64 })}
                        path="/referrals"
                    />
                    <FeatureCard
                        text="Profile"
                        iconSrc={getImageKitUrl(RemoteImages.profile, { width: 64, height: 64 })}
                        path="/profile"
                    />
                    <FeatureCard
                        text="Earnings"
                        iconSrc={getImageKitUrl(RemoteImages.bank, { width: 64, height: 64 })}
                        path="/earnings"
                    />
                    <FeatureCard
                        text="City wise bonus"
                        iconSrc={getImageKitUrl(RemoteImages.coin, { width: 64, height: 64 })}
                        path="/city-bonus"
                    />
                </CardsContainer>
                <ReferralView />
                <PromoWidget />
                <Referrals />
                <ReferralEarnings />
            </HomePageContainer>
        </>
    );
};

const Home = () => {
    return (
        <HomeDataProvider>
            <HomeContent />
        </HomeDataProvider>
    );
};

export default Home;
